module.exports = __webpack_public_path__ + "static/2-e8a3b385a5eb961f42d9ffcb64caf991.jpg";